import React from "react";
import { Paper, Box } from "@mui/material";

import ApiAttribute from "components/ApiAttribute/ApiAttribute";
import TabPanel from "components/ApiTabPanel/ApiTabPanel";

export function TabPanelObject(props) {
  const {
    friendlyName,
    value,
    parentAttributes,
    childAttributes,
    exampleJson,
  } = props;

  return (
    <TabPanel value={value} index={0}>
      <Box style={{ width: "58%" }}>
        <h3>{friendlyName} object</h3>
        <p style={{ fontWeight: 400 }}>Attributes</p>
        {parentAttributes.map((attribute) => (
          <ApiAttribute
            key={attribute.name}
            name={attribute.name}
            type={attribute.type}
            description={attribute.description}
            readOnly={attribute.readOnly}
            newField={attribute.newField}
          />
        ))}
        {childAttributes && childAttributes.length > 0 && (
          <React.Fragment>
            <hr />
            <h3>{friendlyName} line item object</h3>
            {childAttributes.map((attribute) => (
              <ApiAttribute
                key={attribute.name}
                name={attribute.name}
                type={attribute.type}
                description={attribute.description}
                readOnly={attribute.readOnly}
              />
            ))}
          </React.Fragment>
        )}
      </Box>
      <Box style={{ width: "9%" }} />
      <Box style={{ width: "33%" }} className="example-json">
        <Paper>
          <div className="title">
            <div className="method-example-response-title">Example JSON</div>
          </div>
          <hr />
          <div className="json-content">
            <pre>
              <code>{exampleJson}</code>
            </pre>
          </div>
        </Paper>
      </Box>
    </TabPanel>
  );
}
